import React from 'react';

/**
 * Modale de progression du Paramétrage (ex-`SetupProgressModal`).
 * Renommée et dé-émojisée au lot 5.4.
 */
function ParamProgressModal({ show, step, message }) {
    if (!show) return null;

    return (
        <div className="progress-overlay">
            <div className="progress-modal">
                <div className="progress-title">
                    <i className="fa-solid fa-spinner fa-spin" /> Enregistrement en cours…
                </div>
                <div className="progress-bar-container">
                    <div className="progress-bar" style={{ width: step + '%' }}></div>
                </div>
                <div className="progress-message">{message}</div>
                <div className="progress-percent">{step}%</div>
            </div>
        </div>
    );
}

export default ParamProgressModal;
